import {
    useEffect
} from "react";
import {
    type INCoreUIKitIconProps
} from "../../../types";
import {
    warnOnce
} from "../../../utils/development";
import Loading from "../../../components/loading";

const LoadingIcon = ({
    color = "emphasized",
    customColor,
    size = 22,
    style
}: INCoreUIKitIconProps) => {
    useEffect(() => {
        warnOnce({
            message: "LoadingIcon is deprecated and will be removed in the next major version. Use Loading with variant=\"brand\" instead."
        });
    }, []);

    return <Loading
        customColor={customColor}
        aria-hidden={true}
        variant="brand"
        color={color}
        style={style}
        size={size}
    />;
};
export default LoadingIcon;
